/**
 * This method will return the fetch params step
 * @returns {object}
 */
export function getStepFetchParams() {
  return {
    with_flow_step_fields_data: true,
    with_flow_step_field_field_data: true,
    with_field_options_data: true,

    with_flow_step_file_data: true,

    with_flow_step_messages_data: true,
    with_flow_step_message_message_template_data: true,

    with_flow_step_questionnaire_data: true,
    with_questionnaire_questions_data: true,
    with_question_image_data: true,
    with_question_answers_data: true,

    with_flow_step_parking_locations_data: true,

    with_flow_step_reference_field_data: true,
  };
}

/**
 * This method will return the fetch params for the visitor
 * @returns {object}
 */
export function getVisitorFetchParams() {
  return {
    with_visitor_fields_data: true,
    with_visitor_houserules_data: true,
    with_visitor_question_answers_data: true,
    with_visitor_visitor_type_data: true,
    with_visitor_employee_data: true,
    with_visitor_sign_in_terminal_data: true,
    with_visitor_language_data: true,
    with_visitor_external_ids_data: true,
  };
}

/**
 * This method will return the flow data from the visitor object
 * @param {object} visitor
 * @returns {object}
 */
export function getFlowDataFromVisitor(visitor) {
  const data = {};
  if (!visitor) return data;

  data.employee_id = visitor.employee?.id ?? visitor.employee;
  data.parking_location_id =
    visitor.parking_location?.id ?? visitor.parking_location;
  data.license_plate = visitor.license_plate;
  data.email = visitor.email;

  // Set the visitor fields
  visitor.fields.forEach((visField) => {
    data[`field_${visField.field}`] = visField.value ?? visField.field_option;
  });

  // Set the visitor houserules
  visitor.houserules.forEach((visHouserule) => {
    data[`houserules_${visHouserule.file}`] = true;
  });

  // Set the visitor question answers
  visitor.question_answers.forEach((visQuestionAnswer) => {
    data[`question_${visQuestionAnswer.question}`] = visQuestionAnswer.answer;
  });

  return data;
}
